import {Avatar, Button, DatePicker, Input, Radio} from 'antd'
import FieldsFactory from 'components/form/FieldsFactory'
import FormActionBar from 'components/form/FormActionBar'
import Pure from 'components/Pure'
import {Formik} from 'formik'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import withTranslate from 'modules/local/withTranslate'
import React, {useContext, useMemo, useState} from 'react'
import {compose, mapProps} from 'recompose'
import {createControlledFormField} from 'views/AppLocals/factory/createFormField'
import {deepTranslate, NullAsDefault, renderIf, shallowDiff} from 'views/Shared'
import {ActionModalWrapper} from "../../../../components/form/ActionModalWrapper";
import {appClassNames} from "../../custom/appClassNames";
import {createValue} from "../../../../components/form/utils";
import {GenderTypes, StatusTypes} from "../../appFieldTypes";
import Translate from "../../../../modules/local/Translate";
import LookupField from "../../../../components/LookupField";
import {SaintsOutlineSvg} from "../../../../components/Svgs/SaintsPlaceholder";
import UserLookupComponent from "../../../../components/UserLookupComponent";
import {getDateString, parseDayjs} from "../../../../helpers/datetimeHelpers";
import {RiUser2Fill} from "react-icons/ri";
import {gConfigs} from "../../configs";
import {IoCalendarOutline} from "react-icons/io5";
import dayjs from "dayjs";
import {BsFillPersonLinesFill, BsImage, BsInfoCircleFill, BsPersonCircle, BsPersonFill} from "react-icons/bs";
import AvatarUploader from "../../../Workspace/components/AvatarUploader";
import {FaPhone} from "react-icons/fa6";
import {FaRegUserCircle} from "react-icons/fa";
import {PiCursor} from "react-icons/pi";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {useLocation} from "react-use";
import {useRouteSearchParam} from "../../../../envs/_current/history";
import usePaginationHelper, {createPagerKey} from "../../hooks/usePaginationHelper";
import {bindQueryParams} from "../../functions/routerHelper";
import {NoneStickyMeta} from "../../EntityList";
import {member_getMembers_Api} from "../../../../apis";
import getTitle from "../../../../helpers/getTitle";

export const formSchema = {

    contact_email__phone: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                label: 'email',
                name: 'contact_email',
                component: createControlledFormField({
                    type: 'email',
                    placeholder: 'ex: email',
                    autoComplete: false,
                    Component: Input,
                }),
            },
            {
                label: 'phone',
                name: 'contact_phone',
                component: createControlledFormField({
                    type: 'tel',
                    placeholder: 'ex: phone',
                    autoComplete: false,
                    Component: Input,
                }),
            },
        ]
    },

    contact_email: {
        title: 'email',
        children: [
            {
                name: 'contact_email',
                component: createControlledFormField({
                    type: 'email',
                    placeholder: 'ex: email',
                    autoComplete: false,
                    Component: Input,
                }),
            },
        ],
    },
    contact_phone: {
        title: 'phone',
        children: [
            {
                name: 'contact_phone',
                component: createControlledFormField({
                    type: 'tel',
                    placeholder: 'ex: phone',
                    autoComplete: false,
                    Component: Input,
                }),
            },
        ],
    },

    contact_address: {
        title: 'address',
        children: [
            {
                name: 'contact_address',
                component: createControlledFormField({
                    placeholder: 'ex: address',
                    autoComplete: false,
                    Component: Input,
                }),
            },
        ],
    },
    patron_saint__fullname: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
        itemClassNames: ['col-span-1', 'col-span-1 md:col-span-2'],
        children: [
            {
                label: 'holy name',
                name: 'patron_saint',
                component: ({name, value, onChange, form}) => (
                    <Translate>
                        {(t) => (
                            <LookupField
                                title={t('choose patron saint')}
                                createIfNotExists={true}
                                defaultValue={form?.values?.patron_saint_name}
                                selectedOption={form?.values?.patron_saint}
                                apiPath={`/lookup/saint/get-by-types`}
                                name={name}
                                OptionWrapper={({children, ...props}) =>
                                    <div
                                        className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                        {children}
                                    </div>
                                }
                                renderOption={(o, i) => {
                                    return (
                                        <div key={i} className="flex items-center flex-1 gap-3">
                                            <Avatar
                                                size={50}
                                                src={o.avatar}
                                                className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                icon={<SaintsOutlineSvg size={30} style={{color: '#dddddd'}}/>}
                                            />
                                            <div className="flex flex-col flex-1">
                                                <span className="font-bold text-sm text-color-000 leading-snug">
                                                    {`${o.common_name || o.name} (${o.patron_saint_feast_day || o.feast_day})`}
                                                </span>
                                                {renderIf(
                                                    o?.description,
                                                    <span className="text-xs text-color-400 italic max-lines-1">
                                                        {o?.description}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }}
                                handleChange={(e) => {
                                    form.setValues({
                                        ...form.values,
                                        patron_saint: e.target,
                                        patron_saint_name: e.target.common_name || e.target.value,
                                        patron_saint_feast_day: e.target.feast_day,
                                        patron_saint_id: e.target.id
                                    })
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                label: 'fullname',
                name: 'name',
                required: true,
                component: ({name, value, form, onChange}) => (
                    <Translate>
                        {(t) => (
                            <div className="flex flex-col gap-1">
                                <Input.Group
                                    compact
                                    style={{display: 'inline-flex', alignItems: 'center'}}
                                    className="custom-input-group">
                                    <Input
                                        name={name}
                                        value={value}
                                        onChange={onChange}
                                        allowClear={true}
                                        placeholder={t('Enter your name')}
                                        style={{borderRadius: '0.375rem 0 0 0.375rem'}}
                                        className="flex-1"
                                    />
                                    <UserLookupComponent
                                        handleApply={(userInfo) => {
                                            const {values, setValues} = form ?? {}
                                            const {
                                                name,
                                                email, gender,
                                                phone_number,
                                                date_of_birth,
                                                address,
                                                patron_saint,
                                                patron_saint_name,
                                            } = userInfo ?? {}

                                            const user_info = _.omitBy(
                                                {
                                                    email,
                                                    gender: _.find(GenderTypes, {value: gender})?.value,
                                                    date_of_birth: String(date_of_birth ?? '').length > 0 ? parseDayjs(date_of_birth) : undefined,
                                                    name: String(name ?? '').length > 0 ? name : undefined,
                                                    contact_phone: phone_number ? phone_number : undefined,
                                                    contact_email: email ?? undefined,
                                                    contact_address: address ?? undefined,

                                                    user: userInfo,
                                                    user_id: userInfo?.id,

                                                    patron_saint: patron_saint,
                                                    patron_saint_id: patron_saint?.id,
                                                    patron_saint_name: patron_saint_name,
                                                },
                                                _.isUndefined
                                            )
                                            setValues({
                                                ...values,
                                                ...(user_info ?? {}),
                                                refreshKey: Date.now()
                                            })
                                        }}>
                                        <Button
                                            type="primary"
                                            style={{width: 46, border: '1px solid transparent'}}
                                            icon={<PiCursor size={14}
                                                            className="hover:opacity-85 cursor-pointer"/>}
                                            className="flex flex-center"
                                        />
                                    </UserLookupComponent>
                                </Input.Group>
                                <span className="text-xs text-color-500 italic leading-tight">
                                    {`* `}
                                    {t('click on {n} to, lookup user accounts on the {m} platform', {
                                        n: (
                                            <PiCursor size={13} className="mx-1 text-color-000"/>
                                        ),
                                        m: (
                                            <span
                                                className="font-bold text-blue-600 tracking-widest">{'Kristo Network'}</span>
                                        ),
                                    })}
                                </span>
                            </div>
                        )}
                    </Translate>
                ),
            },
        ],
    },
    date__place_of_birth_gender: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                label: 'date of birth',
                name: 'date_of_birth',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        className: 'w-full',
                        format: gConfigs.dateFormat,
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: `${translate('date of birth')} "DD/MM/YYYY"`,
                        // 🔹 Giới hạn ngày
                        disabledDate: (current) => {
                            const maxDate = dayjs().subtract(5, 'year');
                            const minDate = dayjs().subtract(120, 'year');

                            return (
                                current &&
                                (current > maxDate.endOf('day') || current < minDate.startOf('day'))
                            );
                        },
                        // 🔹 mở lịch ở khoảng năm hợp lý
                        defaultPickerValue: value ?? dayjs().subtract(30, 'year'),
                        onChange: (date, dateString) => {
                            onChange(createValue(name, date ? dayjs(new Date(date)) : null))
                        },
                    }))
                )(DatePicker),
            },
            {
                label: 'gender',
                name: 'gender',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        onChange,
                        buttonStyle: 'solid',
                        className: 'w-full custom-radio-button',
                        children: Object.values(GenderTypes).map(
                            ({name, value, label}) => (
                                <Radio.Button
                                    style={{padding: '0px 10px'}}
                                    key={name}
                                    value={value}>
                                    {translate(label)}
                                </Radio.Button>
                            )
                        ),
                    }))
                )(Radio.Group),
            },
        ],
    },

    avatar: {
        children: [
            {
                name: 'avatar',
                component: createControlledFormField({
                    withValues: ({avatar_preview}) => ({
                        value: avatar_preview,
                        width: 150,
                        height: 150,
                        icon: <BsImage size={70} style={{color: '#eaeaea'}}/>,
                    }),
                    Component: AvatarUploader,
                }),
            },
        ],
    },

    position_title: {
        title: 'position title',
        children: [
            {
                name: 'position_title',
                component: ({name, value, onChange, form}) => {
                    const values = _.get(form, 'values', {})
                    const organization = _.get(values, 'organization', {})

                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    createIfNotExists={true}
                                    defaultValue={
                                        values?.position_title
                                    }
                                    apiPath={`/lookup/position_title/gets?group_type=organization_department`}
                                    name={name}
                                    placeholder={t('choose or create')}
                                    handleChange={(e) => {
                                        onChange(
                                            createValue('position_title', e.target.value)
                                        )
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },

    started_finished_date: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                name: 'from_date',
                label: 'from date',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        className: 'w-full',
                        format: gConfigs.dateFormat,
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: translate('ex: 20/10/2010'),
                        onChange: (date, dateString) => {
                            onChange(createValue(name, date ? dayjs(new Date(date)) : null))
                        },
                    }))
                )(DatePicker),
            },
            {
                name: 'to_date',
                label: 'to date',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        className: 'w-full',
                        format: gConfigs.dateFormat,
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: translate('ex: 20/10/2010'),
                        onChange: (date, dateString) => {
                            onChange(createValue(name, date ? dayjs(new Date(date)) : null))
                        },
                    }))
                )(DatePicker),
            },
        ],
    },
}

export const OrganizationDepartmentCreateMemberForm = ({
                                                           organization,
                                                           organizationDepartment,
                                                           initialValues,
                                                           onSubmit = NullAsDefault,
                                                           isSubmitting = false,
                                                       }) => {
    const t = useTranslate()

    const status_options = [StatusTypes.PENDING__1, StatusTypes.NORMAL, StatusTypes.CLOSED]

    const _initialValues = useMemo(
        () => ({
            name: undefined,
            notes: undefined,
            active: 1, status: 1,
            organization_id: organization?.id,
            organization_department_id: organizationDepartment?.id,
            ...(initialValues ?? {}),
            status_options: status_options.map(deepTranslate(t)),
            owner: organization
        }),
        [organization, initialValues]
    )

    const validate = (values) => {
        let errors = {}

        const {name} = values ?? {}

        if (_.isEmpty(name ?? '')) {
            errors.name = t('required field')
        }

        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={(values) => {
                const {
                    date_of_birth, from_date, to_date,
                    ...rest
                } = values ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                            date_of_birth: !!date_of_birth ? getDateString(date_of_birth) : undefined,
                            from_date: !!from_date ? getDateString(from_date) : undefined,
                            to_date: !!to_date ? getDateString(to_date) : undefined,
                        },
                        _.isUndefined
                    )
                )
            }}>
            <ActionModalWrapper action={<FormActionBar submitText="create"/>}>
                <Pure>
                    <div className="flex flex-col gap-6">
                        <div className="p-3 border-l-4 border-color-300 rounded-lg shadow">
                            <div className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
                                <BsPersonFill size={20} className="mr-2 text-color-500"/>
                                {t('member information')}
                            </div>
                            <div className="flex flex-col gap-3">
                                <FieldsFactory
                                    formSchema={[
                                        formSchema.patron_saint__fullname,
                                        formSchema.date__place_of_birth_gender,
                                    ]}
                                />
                            </div>
                        </div>
                        <div className="p-3 border-l-4 border-blue-600 rounded-lg shadow">
                            <div className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
                                <FaPhone size={16} className="mr-2 text-blue-500"/>
                                {t('contact information')}
                            </div>
                            <div className="flex flex-col gap-3">
                                <FieldsFactory
                                    formSchema={[
                                        formSchema.contact_email__phone,
                                        formSchema.contact_address,
                                    ]}
                                />
                            </div>
                        </div>

                        <div className="p-3 border-l-4 border-blue-600 rounded-lg shadow">
                            <div className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
                                <BsInfoCircleFill size={18} className="mr-2 text-blue-500"/>
                                {t('position information')}
                            </div>
                            <div className="flex flex-col gap-3">
                                <FieldsFactory
                                    formSchema={[
                                        formSchema.position_title,
                                        formSchema.started_finished_date
                                    ]}
                                />
                            </div>
                        </div>

                    </div>
                </Pure>
            </ActionModalWrapper>
        </Formik>
    )
}


export const OrganizationDepartmentAddMemberForm = ({
                                                        organization,
                                                        organizationDepartment,
                                                        initialValues,
                                                        onSubmit = NullAsDefault,
                                                        isSubmitting = false,
                                                        filter_actions = {
                                                            sortBy: 'sort-by',
                                                            keyword: 'keyword',
                                                        },
                                                    }) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const location = useLocation()
    const [refreshKey, setRefreshKey] = useState()
    const keyword = useRouteSearchParam(filter_actions.keyword)
    const sortBy = useRouteSearchParam(filter_actions.sortBy)
    const refresh_deps = useMemo(
        () => [
            keyword,
            refreshKey,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [keyword, refreshKey, location.state]
    )


    const [pager_widget] = usePaginationHelper({
        sortHeader: null,
        SortByWidget: NullAsDefault,
        isToggleDefault: true,
        AdvancedFilter: NullAsDefault,
        renderFilter: NullAsDefault,
        query_params: filter_actions,
        withKey: createPagerKey(refresh_deps),
        pagerInfo: {
            RenderEntity: React.Fragment,
            query: bindQueryParams([{prop: 'organization'}, {id: organization?.id}]),
            values: {organization_department_id: organizationDepartment?.id},
            PaginationMeta: NoneStickyMeta,
            apiInfo: member_getMembers_Api,
            renderItem: ((record, index) => {
                return (
                    <div
                        key={index}
                        className="p-3 border border-color-50 hover:scale-2xs hover:shadow-md rounded-xl transition duration-300">
                        <div className="flex gap-3 justify-between items-center">
                            <Avatar
                                size={50}
                                src={record?.user?.avatar}
                                icon={<RiUser2Fill size={25} className="text-color-500"/>}
                                className="flex flex-center background-200"
                            />
                            <div className="flex flex-col flex-1">
                                <span className="font-bold text-base text-color-000 tracking-wide">
                                    {getTitle(record) || getTitle(record?.user)}
                                </span>
                                <span className="text-sm-em text-color-300 italic tracking-wider">
                                    {record?.contact_email}
                                </span>
                            </div>
                            <Button
                                size="small"
                                color="primary" variant="solid"
                                onClick={() => {
                                    onSubmit(
                                        {
                                            organization_member_id: record?.id,
                                            user_id: record?.user?.id,
                                            name: record?.user?.name || record?.name,
                                            organization_department_id: organizationDepartment?.id
                                        }
                                    )
                                }}
                                style={{ padding: '4px 10px' }}
                                className="button-rounded-lg font-medium text-xs no-border">
                                {t('select')}
                            </Button>
                        </div>
                    </div>
                );
            }),
        },
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onSortChange(sortBy)
            onFilterChange({
                keyword,
            })
        },
        filter_params: {
            keyword,
        },
        dependencies: [
            keyword,
        ],
        renderHeader: ([searchBar, filterBar]) => (
            <div className="flex flex-col gap-3">
                {filterBar}
            </div>
        ),
    })

    return (
        <div className="flex flex-col gap-3">
            {pager_widget}
        </div>
    )
}

export const OrganizationDepartmentUpdateMemberForm = ({
                                                           organization,
                                                           organizationDepartment,
                                                           initialValues,
                                                           onSubmit = NullAsDefault,
                                                           isSubmitting = false,
                                                       }) => {
    const t = useTranslate()
    const _initialValues = useMemo(() => {
        const {date_of_birth, from_date, to_date, avatar, ...rest} = initialValues ?? {}

        return {
            ...rest,
            avatar_preview: avatar,
            date_of_birth: parseDayjs(date_of_birth),
            from_date: !!from_date ? parseDayjs(from_date) : undefined,
            to_date: !!to_date ? parseDayjs(to_date) : undefined,

            patron_saint: rest?.patron_saint,
            patron_saint_id: rest?.patron_saint?.id,
            patron_saint_name: rest?.patron_saint_name || rest?.patron_saint?.common_name,

            organization,
        }
    }, [organization, initialValues])


    const validate = (values) => {
        let errors = {}

        const {name} = values ?? {}

        if (_.isEmpty(name ?? '')) {
            errors.name = t('required field')
        }

        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={(values) => {
                const changes = shallowDiff(values, _initialValues)
                const {
                    date_of_birth, from_date, to_date,
                    ...rest
                } = changes ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                            date_of_birth: !!date_of_birth ? getDateString(date_of_birth) : undefined,
                            from_date: !!from_date ? getDateString(from_date) : undefined,
                            to_date: !!to_date ? getDateString(to_date) : undefined,
                        },
                        _.isUndefined
                    )
                )
            }}>
            <ActionModalWrapper action={<FormActionBar submitText="save"/>} className="gap-4">
                <div className="p-3 border-l-4 border-color-300 rounded-lg shadow">
                    <div
                        className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
                        <FaRegUserCircle size={20} className="mr-2 text-color-500"/>
                        {t('member information')}
                    </div>
                    <div className="flex flex-col gap-3">
                        <FieldsFactory
                            formSchema={[
                                formSchema.patron_saint__fullname,
                                formSchema.date__place_of_birth_gender,
                            ]}
                        />
                    </div>
                </div>
                <div className="p-3 border-l-4 border-color-300 rounded-lg shadow">
                    <div
                        className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
                        <BsPersonCircle size={20} className="mr-2 text-color-500"/>
                        {t('image')}
                    </div>
                    <FieldsFactory formSchema={[formSchema.avatar]}/>
                </div>

                <div className="p-3 border-l-4 border-blue-600 rounded-lg shadow">
                    <div
                        className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
                        <FaPhone size={18} className="mr-2 text-blue-500"/>
                        {t('contact information')}
                    </div>
                    <div className="flex flex-col gap-3">
                        <FieldsFactory
                            formSchema={[
                                formSchema.contact_email__phone,
                                formSchema.contact_address,
                            ]}
                        />
                    </div>
                </div>


                <div className="p-3 border-l-4 border-blue-600 rounded-lg shadow">
                    <div
                        className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
                        <BsFillPersonLinesFill size={18} className="mr-2 text-blue-500"/>
                        {t('position information')}
                    </div>
                    <div className="flex flex-col gap-3">
                        <FieldsFactory
                            formSchema={[
                                formSchema.position_title,
                                formSchema.started_finished_date
                            ]}
                        />
                    </div>
                </div>

            </ActionModalWrapper>
        </Formik>
    )
}

